<template>
  <FormInput
    v-bind="$attrs"
    :model-value="modelValue"
    :type="visible ? 'text' : 'password'"
    :placeholder="placeholder"
    :disabled="disabled"
    :required="required"
    :size="size"
    :autocomplete="autocomplete"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <template v-if="$slots.leading" #leading>
      <slot name="leading" />
    </template>
    <template #trailing>
      <button
        type="button"
        class="flex items-center text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 p-0"
        @click="visible = !visible"
      >
        <font-awesome-icon
          :icon="visible ? 'fa-light fa-eye' : 'fa-light fa-eye-slash'"
        />
      </button>
    </template>
  </FormInput>
</template>

<script setup lang="ts">
  defineOptions({ inheritAttrs: false })

  defineProps({
    modelValue: {
      type: [String, Number],
      default: "",
    },
    placeholder: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "md",
    },
    autocomplete: {
      type: String,
      default: "current-password",
    },
    // Legacy props kept for API compatibility
    color: { type: String, default: null },
    loading: { type: Boolean, default: false },
    padded: { type: Boolean, default: true },
    variant: { type: String, default: null },
  })

  defineEmits(["update:modelValue"])

  const visible = ref(false)
</script>
